{
  "layout": {
    "tagline": "Everything you need to ship, in one place.",
    "subtitle": "Sign in to manage your workspace, your team, and your data."
  },
  "login": {
    "title": "Login",
    "description": "Sign in to your account to continue.",
    "email": "Email",
    "password": "Password",
    "rememberMe": "Remember me",
    "submit": "Sign in",
    "submitting": "Signing in...",
    "forgotPassword": "Forgot password?",
    "magicLink": "Sign in with magic link",
    "or": "or",
    "magicLinkSent": "Magic link sent! Check your email.",
    "magicLinkError": "Failed to send magic link. Please try again.",
    "noAccount": "Don't have an account?",
    "register": "Register",
    "success": "Welcome back!",
    "error": "Invalid email or password. Please try again.",
    "accountLocked": "Your account has been locked due to too many failed attempts. Please check your email to unlock it.",
    "emailNotVerified": "Please verify your email before signing in. Check your inbox for the verification link."
  },
  "register": {
    "title": "Register",
    "description": "Create a new account to get started.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "acceptTerms": "I accept the terms and conditions",
    "submit": "Create account",
    "submitting": "Creating account...",
    "hasAccount": "Already have an account?",
    "login": "Sign in",
    "success": "Account created successfully!",
    "successDescription": "We've sent a verification email to your inbox. Please check your email to verify your account.",
    "error": "Registration failed. Please try again.",
    "passwordStrength": {
      "label": "Password strength",
      "weak": "Weak",
      "fair": "Fair",
      "strong": "Strong"
    }
  },
  "signup": {
    "title": "Create your account",
    "description": "Set up your account and organization in a few quick steps.",
    "stepper": {
      "account": "1 Account",
      "organization": "2 Organization",
      "review": "3 Review",
      "compact": "Step {{current}} of {{total}}",
      "progress": "Signup progress"
    },
    "step1": {
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "password": "Password",
      "confirmPassword": "Confirm password"
    },
    "step2": {
      "orgName": "Organization name",
      "subdomain": "Subdomain"
    },
    "step3": {
      "heading": "Review your details",
      "email": "Email",
      "name": "Name",
      "orgName": "Organization",
      "subdomain": "Address",
      "acceptTerms": "I accept the terms and conditions"
    },
    "availability": {
      "checking": "Checking availability…"
    },
    "email": {
      "taken": "That email is already registered. Try signing in instead."
    },
    "subdomain": {
      "preview": "{{slug}}.myproduct.com",
      "available": "{{slug}}.myproduct.com is available",
      "taken": "That address is taken. Try another."
    },
    "passwordStrength": {
      "label": "Password strength",
      "weak": "Weak",
      "fair": "Fair",
      "strong": "Strong"
    },
    "continue": "Continue",
    "back": "Back",
    "submit": "Create account",
    "submitting": "Creating account...",
    "success": "Account created successfully!",
    "error": "Something went wrong creating your account. Please try again.",
    "hasAccount": "Already have an account?",
    "login": "Sign in"
  },
  "invite": {
    "heading": "You're joining {{tenantName}}",
    "loading": "Checking your invitation…",
    "email": "Email",
    "emailHelper": "This is the address you were invited with.",
    "firstName": "First name",
    "lastName": "Last name",
    "password": "Password",
    "acceptTerms": "I accept the terms and conditions",
    "submit": "Accept invitation",
    "submitting": "Accepting...",
    "success": "Invitation accepted! You can sign in now.",
    "error": "Something went wrong accepting your invitation. Please try again.",
    "invalidHeading": "This invitation isn't valid",
    "invalidBody": "It may have expired or already been used. Ask your admin to send a new invite.",
    "goToSignIn": "Go to sign in",
    "passwordStrength": {
      "label": "Password strength",
      "weak": "Weak",
      "fair": "Fair",
      "strong": "Strong"
    }
  },
  "welcome": {
    "heading": "Welcome to {{orgName}}!",
    "headingGeneric": "Welcome!",
    "body": "Your workspace is ready. Invite your team or jump straight in.",
    "goToDashboard": "Go to dashboard",
    "inviteTeam": "Invite your team"
  },
  "twoFactor": {
    "title": "Two-Factor Authentication",
    "description": "Enter the 6-digit code from your authenticator app.",
    "codeLabel": "Verification code",
    "submit": "Verify",
    "submitting": "Verifying...",
    "useBackupCode": "Use a backup code instead",
    "useAuthenticator": "Use authenticator app",
    "useEmailCode": "Use email code instead",
    "emailCodeSent": "A verification code has been sent to your email.",
    "emailCodeError": "Failed to send email code. Please try again.",
    "emailCodeLabel": "Email verification code",
    "emailCodeDescription": "Enter the 6-digit code sent to your email.",
    "backupCodeLabel": "Backup code",
    "backupCodeDescription": "Enter one of your backup codes.",
    "success": "Verification successful!",
    "error": "Invalid verification code. Please try again.",
    "backupError": "Invalid backup code. Please try again.",
    "emailOtpError": "Invalid email verification code. Please try again.",
    "backToLogin": "Back to login"
  },
  "forgotPassword": {
    "title": "Forgot Password",
    "description": "Enter your email to reset your password.",
    "email": "Email",
    "submit": "Send reset link",
    "submitting": "Sending...",
    "success": "Password reset link sent!",
    "successDescription": "If an account exists with that email, you'll receive a password reset link shortly.",
    "backToLogin": "Back to login",
    "error": "Failed to send reset link. Please try again."
  },
  "resetPassword": {
    "title": "Reset Password",
    "description": "Enter a new password for your account.",
    "password": "New password",
    "confirmPassword": "Confirm new password",
    "submit": "Reset password",
    "submitting": "Resetting...",
    "success": "Password reset successfully!",
    "successDescription": "You have been signed in automatically.",
    "backToLogin": "Back to login",
    "error": "Failed to reset password. Please try again.",
    "invalidToken": "This reset link is invalid or has expired.",
    "twoFactorCode": "Two-factor code",
    "twoFactorHint": "Enter the 6-digit code from your authenticator app to finish resetting your password."
  },
  "checkEmail": {
    "title": "Check Your Email",
    "description": "We've sent a verification email to your inbox.",
    "instructions": "Click the verification link in the email to activate your account.",
    "backToLogin": "Back to login"
  },
  "verifyEmail": {
    "verifying": "Verifying your email…",
    "successHeading": "Email verified",
    "successBody": "Your email address has been verified.",
    "errorHeading": "This verification link isn't valid",
    "errorBody": "It may have expired or already been used. Sign in to request a new one.",
    "goToSignIn": "Go to sign in",
    "continueToWelcome": "Continue"
  }
}
